import Swagger from 'swagger-client'
import apiUrl from './apiUrl'

export default (creds) => {
  return new Swagger({
    url: apiUrl(false),
    usePromise: true,
    authorizations: {
      BasicAuth: new Swagger.PasswordAuthorization(creds)
    }
  })
}



// WEBPACK FOOTER //
// ./src/components/Swagger/login.js